import React, { useState, useMemo, useCallback } from "react";
import {
  useGetTableData2,
  useDeleteData,
  useCreateData,
  usePutData,
} from "../../Plan/tableHooks";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import {
  localizationTextObjectForInformationForMachine,
  itemClickFirst,
  procClickFirst,
} from "../../../../utils/constants";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  TextField,
  InputAdornment,
} from "@mui/material";
import Trash from "../../Nucleo-Icons/trash";
import AtmMachine from "../../Nucleo-Icons/atm-machine";
import CreateMchUsableProc from "./CreateMchUsablProc";
import Pen01 from "../../Nucleo-Icons/pen-01";
import styled from "styled-components";
import SearchIcon from "@mui/icons-material/Search";
import { useParams } from "react-router-dom";
import { AddButton } from "../../../common/Buttons";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import goToHelpLink from "../../../../utils/goToHelpLink";
import { useInsightwinMachineMaster } from "../../hooks";

const EditWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledCheckBox = styled.input`
  width: 32px;
  height: 32px;
`;

//getInsightwinMachineList
function Machine({
  clickedItemId,
  clickedProcId,
  processMasterData,
  onShowConfirmation,
  orderData,
  openSnackbar,
  itemData,
}) {
  const { group_code, project_code } = useParams();
  const [mchUpdateStatus, setMchUpdateStatus] = useState(0);
  const [mchSearchText, setMchSearchText] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const { mchData, isLoading, isFetching } = useGetTableData2(
    mchUpdateStatus,
    `/api/mch/getMachineList?group_code=${group_code}&project_code=${project_code}`,
    "mchData"
  );
  const createMchUsableProc = useCreateData(
    mchUpdateStatus,
    "/api/mch/createUsable",
    openSnackbar
  );
  const deleteMchUsableProc = useDeleteData(
    mchUpdateStatus,
    "/api/mch/deleteUsable",
    openSnackbar
  );
  const updateMchUsableProc = usePutData(
    mchUpdateStatus,
    "/api/mch/updateStatus",
    openSnackbar
  );
  const updateMachinePriority = usePutData(
    mchUpdateStatus,
    "/api/mch/updatePriorities",
    openSnackbar
  );
  const onMchSearchTextChange = useCallback((event) => {
    setMchSearchText(event.target.value);
  }, []);
  const { machineMasterData } = useInsightwinMachineMaster(
    group_code,
    project_code
  );
  const columns = useMemo(() => {
    const allColumns = [
      {
        accessorKey: "machine_id",
        header: "설비 ID",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        muiTableFooterCellProps: { align: "center" },
        size: 50,
        enableEditing: false,
      },
      {
        accessorKey: "machine_name",
        header: "설비명",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        muiTableFooterCellProps: { align: "center" },
        size: 130,
        enableEditing: false,
      },
      {
        accessorKey: "machine_proc_time",
        header: "개별 공정시간",
        muiTableHeadCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
        muiTableFooterCellProps: { align: "center" },
        size: 120,
        Cell: ({ row }) => {
          if (row.original.machine_proc_status === 0) {
            return "사용안함";
          }
          if (
            row.original.machine_proc_time === 0 ||
            row.original.machine_proc_time % 60 === 0
          ) {
            return row.original.machine_proc_time / 60 + "분";
          }
          return (row.original.machine_proc_time / 60).toFixed(1) + "분";
        },
        Edit: ({ row, column, table }) => {
          const [isChecked, setIsChecked] = useState(
            row.original.machine_proc_status === 1
          );
          const [inputValue, setInputValue] = useState(
            row.original.machine_proc_time || ""
          );
          const handleCheckboxChange = (e) => {
            setIsChecked(e.target.checked);
            row.original.machine_proc_status = e.target.checked ? 1 : 0;
            row.original.machine_proc_time =
              e.target.checked && inputValue ? parseFloat(inputValue) : 0;
            table.options.onEditingRowChange?.({
              ...row.original,
              machine_proc_status: e.target.checked ? 1 : 0,
              machine_proc_time:
                e.target.checked && inputValue ? parseFloat(inputValue) : 0,
            });
          };
          const handleInputChange = (e) => {
            const value = e.target.value;
            if (value === "" || (!isNaN(value) && parseFloat(value) > 0)) {
              setInputValue(value);
              row.original.machine_proc_status = isChecked ? 1 : 0;
              row.original.machine_proc_time =
                value === "" ? 0 : parseFloat(value);
              table.options.onEditingRowChange?.({
                ...row.original,
                machine_proc_status: isChecked ? 1 : 0,
                machine_proc_time: value === "" ? 0 : parseFloat(value),
              });
            }
          };
          return (
            <EditWrapper>
              <StyledCheckBox
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              {isChecked ? (
                <TextField
                  type="number"
                  value={inputValue}
                  onChange={handleInputChange}
                  placeholder="시간입력"
                  size="small"
                  inputProps={{
                    step: "0.1",
                    min: "0",
                    style: {
                      height: "35px",
                      padding: "0 8px",
                      fontSize: "14px",
                      textAlign: "center",
                    },
                  }}
                  style={{
                    height: "36px",
                  }}
                />
              ) : (
                <TextField
                  value="사용안함"
                  disabled
                  size="small"
                  inputProps={{
                    style: {
                      height: "35px",
                      padding: "0 8px",
                      textAlign: "center",
                      color: "#666",
                      backgroundColor: "#f5f5f5",
                      cursor: "not-allowed",
                      opacity: "0.6",
                    },
                  }}
                  style={{
                    height: "36px",
                  }}
                />
              )}
            </EditWrapper>
          );
        },
      },
    ];
    if (clickedItemId && clickedProcId) {
      return allColumns;
    } else {
      return allColumns.filter(
        (column) =>
          column.accessorKey !== "proc_id" && column.accessorKey !== "priority"
      );
    }
  }, [machineMasterData, processMasterData, clickedItemId, clickedProcId]);
  const handleUpdateMchUsableProc = async ({ values, table, row }) => {
    const obj = {
      item_id: row.original.item_id,
      machine_id: row.original.machine_id,
      machine_proc_status: row.original.machine_proc_status,
      machine_proc_time: row.original.machine_proc_time,
      proc_id: row.original.proc_id,
      group_code,
      project_code,
    };
    if (
      obj.machine_proc_status === 1 &&
      (obj.machine_proc_time <= 0 || !obj.machine_proc_time)
    ) {
      openSnackbar("개별 공정시간은 1 이상 입력해 주세요.", "info");
      return;
    }
    await updateMchUsableProc.mutateAsync(obj);
    table.setEditingRow(null);
  };
  const handleCreateMchUsableProc = async ({ values, table }) => {
    onShowConfirmation({
      title: "설비 정보 추가",
      mainText: "설비 정보를 추가합니다.",
      subText: "",
      onConfirm: async () => {
        try {
          const createData = [
            [clickedItemId, clickedProcId, group_code, project_code],
            [...values],
          ];
          await createMchUsableProc.mutateAsync(createData);
          table.setCreatingRow(null);
        } catch (error) {
          console.error("Error creating machine:", error);
        }
      },
    });
  };
  const openDeleteConfirm = async (row) => {
    onShowConfirmation({
      title: "설비 정보 삭제",
      mainText: "이 작업은 되돌릴 수 없습니다. 진행하시겠습니까?",
      onConfirm: async () => {
        try {
          await deleteMchUsableProc.mutateAsync({
            itemId: clickedItemId,
            procId: row.original.proc_id,
            machineId: row.original.machine_id,
            group_code,
            project_code,
          });
        } catch (error) {
          console.error("Error deleting process:", error);
        }
      },
    });
  };
  const tableData = useMemo(() => {
    if (!clickedItemId || !clickedProcId) return [];
    let filteredData = mchData
      .filter((i) => i.item_id === clickedItemId && i.proc_id === clickedProcId)
      .sort((a, b) => a.priority - b.priority);
    if (mchSearchText.trim()) {
      const searchTerm = mchSearchText.toLowerCase();
      filteredData = filteredData.filter(
        (machine) =>
          machine.machine_name?.toLowerCase().includes(searchTerm) ||
          machine.machine_id?.toString().includes(searchTerm)
      );
    }
    return filteredData;
  }, [clickedItemId, clickedProcId, mchData, mchSearchText]);
  const table = useMaterialReactTable(
    {
      data: tableData ?? [],
      columns,
      state: {
        isLoading,
        showProgressBars: isFetching,
        pagination,
      },
      onPaginationChange: setPagination,
      enableColumnFilters: false,
      enableColumnFilterModes: false,
      enableColumnOrdering: false,
      enableSorting: false,
      enableStickyHeader: true,
      enableColumnActions: false,
      enableEditing: true,
      onCreatingRowSave: handleCreateMchUsableProc,
      onEditingRowSave: handleUpdateMchUsableProc,
      onEditingRowCancel: () => {
        table.setEditingRow(null);
      },
      localization: localizationTextObjectForInformationForMachine,
      createDisplayMode: "modal",
      editDisplayMode: "row",
      autoResetPageIndex: false,
      // manualPagination: true,
      enableFullScreenToggle: false,
      enableDensityToggle: false,
      paginationDisplayMode: "pages",
      enableRowOrdering: false,
      // muiRowDragHandleProps: ({ row, table }) => {
      //   const currentPageRows = table.getRowModel().rows;
      //   const isFirstRowOnPage = currentPageRows[0]?.id === row.id;
      //   const isLastRowOnPage =
      //     currentPageRows[currentPageRows.length - 1]?.id === row.id;
      //   const isSingleRowOnPage = currentPageRows.length === 1;
      //   return {
      //     sx: {
      //       width: "30px",
      //       height: "30px",
      //       textAlign: "center",
      //       position: "absolute",
      //       top: "50%",
      //       left: "50%",
      //       transform: "translate(-50%, -50%)",
      //       "& svg": {
      //         display: "none",
      //       },
      //       "::before": {
      //         content: () => {
      //           if (isSingleRowOnPage) {
      //             return "url(/icons/cursor-not-allowed.svg)";
      //           }
      //           if (isFirstRowOnPage) {
      //             return "url(/icons/arrow-down-from-line.svg)";
      //           }
      //           if (isLastRowOnPage) {
      //             return "url(/icons/arrow-up-from-line.svg)";
      //           }
      //           return "url('/icons/arrows-from-line-y.svg')";
      //         },
      //         width: "30px",
      //         height: "30px",
      //       },
      //     },
      //     onDragEnd: async () => {
      //       const { draggingRow, hoveredRow } = table.getState();
      //       if (hoveredRow && draggingRow) {
      //         const newData = [...tableData];
      //         newData.splice(
      //           hoveredRow.index,
      //           0,
      //           newData.splice(draggingRow.index, 1)[0]
      //         );
      //         const arr = newData.map((c, i) => {
      //           return {
      //             machine_id: c.machine_id,
      //             item_id: c.item_id,
      //             proc_id: c.proc_id,
      //             priority: i + 1,
      //             group_code,
      //             project_code,
      //           };
      //         });
      //         await updateMachinePriority.mutateAsync(arr, {
      //           onSuccess: () => {
      //             openSnackbar("설비 우선순위를 변경하였습니다.");
      //           },
      //         });
      //       }
      //     },
      //   };
      // },
      muiTableBodyRowProps: ({ row }) => ({
        sx: {
          cursor: "pointer",
          background: () => {
            return "#F8F7FA !important";
          },
        },
      }),
      muiTablePaperProps: {
        sx: {
          width: "100%",
          height: "100%",
          background: "#fff",
          "& .css-qc99f7": {
            position: "absolute !important",
            bottom: "30px",
            borderBottom: "1px solid #d6d8df",
          },
        },
      },
      muiTableHeadProps: {
        sx: {
          "& tr": {
            borderRadius: "12px",
            background: "#f3f6f9",
            color: "#464e5f",
            "& th": {
              fontWeight: "500 !important",
              color: "black",
              padding: "0.5rem",
              fontSize: "15px",
              "&:first-child div": {
                justifyContent: "center",
              },
            },
          },
        },
      },
      muiTableBodyCellProps: {
        sx: {
          color: "black",
          fontWeight: "500",
          fontSize: "14px",
        },
      },
      renderTopToolbarCustomActions: ({ table }) => (
        <Box
          sx={{
            height: "40px",
            width: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            fontSize: "22px",
            background: "#F8F7FA",
            fontWeight: "700",
            gap: "1rem",
            paddingLeft: "0.53rem",
          }}
        >
          <AtmMachine />
          설비{" "}
          <Tooltip
            title="이동"
            sx={{ cursor: "pointer" }}
            onClick={() =>
              goToHelpLink(
                "http://esehelp.cafe24.com/scheduler#h-8-3-%EA%B0%80%EC%9A%A9%EC%9E%A5%EB%B9%84-%EA%B4%80%EB%A6%AC-%EC%98%81%EC%97%AD"
              )
            }
          >
            <HelpOutlineIcon />
          </Tooltip>
        </Box>
      ),
      renderToolbarInternalActions: ({ table }) => (
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          {/* <TextField
            placeholder="검색어를 입력하세요"
            variant="outlined"
            sx={{
              width: "65%",
              marginBottom: "0px",
            }}
            size="small"
            value={mchSearchText}
            onChange={onMchSearchTextChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          /> */}
          <AddButton
            onClick={() => {
              if (!clickedItemId) {
                openSnackbar(itemClickFirst, "info");
                return;
              }
              if (!clickedProcId) {
                openSnackbar(procClickFirst, "info");
                return;
              }
              if (tableData.length > 1) {
                openSnackbar(
                  "설비 정보는 최대 1개까지 추가할 수 있습니다.",
                  "warning"
                );
                return;
              }
              table.setCreatingRow(true);
            }}
          />
        </div>
      ),
      positionActionsColumn: "last",
      renderRowActions: ({ row, table }) => (
        <Box sx={{ display: "flex" }}>
          <Tooltip title="Edit">
            <IconButton onClick={() => table.setEditingRow(row)}>
              <Pen01 />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              color="error"
              onClick={async () => {
                await openDeleteConfirm(row);
              }}
            >
              <Trash />
            </IconButton>
          </Tooltip>
        </Box>
      ),
      renderCreateRowDialogContent: ({
        table,
        row,
        internalEditComponents,
      }) => (
        // create modal?
        // 선택한 순서대로 priority 부여.
        <CreateMchUsableProc
          table={table}
          machineMasterData={machineMasterData}
          clickedProcId={clickedProcId}
          processMasterData={processMasterData}
          open={true}
          onClose={() => table.setCreatingRow(null)}
          clickedItemId={clickedItemId}
          itemData={itemData}
          tableData={tableData}
          handleCreateMchUsableProc={handleCreateMchUsableProc}
        />
      ),
      muiBottomToolbarProps: {
        sx: {
          position: "absolute !important",
          bottom: "42px",
          left: "50%",
          width: "inherit",
          transform: "translate(-50%, -50%)",
          "& .MuiTablePagination-root .MuiBox-root": {
            display: "none !important",
          },
        },
      },
    },
    [tableData, columns]
  );
  return (
    <MaterialReactTable
      muiTableBodyProps={{
        sx: { overflow: "visible" },
      }}
      table={table}
    />
  );
}

export default Machine;
